import { firebase, FirebaseContext, FirebaseProvider } from "./config/firebase.client";

import store from "./store/store";
import * as caractions from "./actions/caractions";
import * as GeoFunctions from "./other/GeoFunctions";
import * as chatactions from "./actions/chatactions";
import * as tripactions from "./actions/tripactions";
import * as taskactions from "./actions/taskactions";
import * as authactions from "./actions/authactions";
import * as panicActions from "./actions/panicActions";
import * as promoactions from "./actions/promoactions";
import * as usersactions from "./actions/usersactions";
import * as DateFunctions from "./other/DateFunctions";
import * as planssactions from './actions/planssactions';
import * as bookingactions from "./actions/bookingactions";
import * as paymentactions from "./actions/paymentactions";
import * as bannersactions from "./actions/bannersactions";
import * as addressactions from "./actions/addressactions";
import * as cartypeactions from "./actions/cartypeactions";
import * as estimateactions from "./actions/estimateactions";
import * as locationactions from "./actions/locationactions";
import * as settingsactions from "./actions/settingsactions";
import * as languageactions from "./actions/languageactions";
import * as withdrawactions from "./actions/withdrawactions";
import * as GoogleAPIFunctions from "./other/GoogleAPIFunctions";
import * as bookinglistactions from "./actions/bookinglistactions";
import * as notificationactions from "./actions/notificationactions";
import * as cancelreasonactions from "./actions/cancelreasonactions";
import * as driverearningaction from "./actions/driverearningaction";
import * as NotificationFunctions from "./other/NotificationFunctions";
import * as earningreportsaction from "./actions/earningreportsaction";
import * as paymentPagoparActions from './actions/paymentPagoparActions';


import * as GetAppIdFromUrl from "./other/GetAppIdFromUrl";
import countries from "./other/GetCountries";
import * as Masks from "./other/masks";
import * as I18n from "./types/i18n";
import * as Types from "./types";

const api = {
  ...caractions,
  ...authactions,
  ...taskactions,
  ...chatactions,
  ...tripactions,
  ...promoactions,
  ...usersactions,
  ...panicActions,
  ...GeoFunctions,
  ...planssactions,
  ...DateFunctions,
  ...addressactions,
  ...bookingactions,
  ...paymentactions,
  ...bannersactions,
  ...cartypeactions,
  ...estimateactions,
  ...locationactions,
  ...settingsactions,
  ...languageactions,
  ...withdrawactions,
  ...bookinglistactions,
  ...GoogleAPIFunctions,
  ...notificationactions,
  ...cancelreasonactions,
  ...driverearningaction,
  ...earningreportsaction,
  ...NotificationFunctions,
  ...paymentPagoparActions,


  countries: countries,
  GetAppIdFromUrl,
  masks: Masks,
  types: Types,
  i18n: I18n,
};

export {
  FirebaseProvider,
  FirebaseContext,
  firebase,
  store,
  api,
};